import React from 'react';
import { logout } from '../../helpers/auth';
import { CallbackTranslation } from '../../locale/localizationContext';
import { AppDispatch } from '../../redux/core';
import { Routes } from '../../routes/types';
import {
  UserIcon,
  SoundIcon,
  PackageIcon,
  LocationsIcon,
  // AddUserIcon,
  PapersIcon,
  GoOutIcon,
  GoInIcon,
} from '../Icons';
import { MenuItem } from './SideMenu';

export const getAuthenticatedMenuElement = (
  t: CallbackTranslation,
  dispatch: AppDispatch
): MenuItem[] => [
  {
    name: t('menu.account'),
    icon: <UserIcon />,
    link: Routes.Profile,
  },
  {
    name: t('menu.news'),
    icon: <SoundIcon />,
    link: Routes.NewsList,
  },
  {
    name: t('menu.orders'),
    icon: <PackageIcon />,
    link: Routes.Orders,
  },
  {
    name: t('menu.addresses'),
    icon: <LocationsIcon />,
    link: Routes.Addresses,
  },
  // {
  //   name: t('menu.inviteFriend'),
  //   icon: <AddUserIcon />,
  //   link: null,
  // },
  {
    name: t('menu.termsAndConditions'),
    icon: <PapersIcon />,
    link: Routes.TermsAndConditions,
  },
  {
    name: t('pageTitles.privacy'),
    icon: <PapersIcon />,
    link: Routes.PrivacyPolicy,
  },
  {
    name: t('menu.logout'),
    icon: <GoOutIcon />,
    link: null,
    action: () => logout(dispatch),
  },
];

export const getAnonymousMenuElement = (t: CallbackTranslation): MenuItem[] => [
  {
    name: t('menu.signIn'),
    icon: <GoInIcon />,
    link: Routes.SignIn,
  },
  {
    name: t('menu.news'),
    icon: <SoundIcon />,
    link: Routes.NewsList,
  },
  {
    name: t('menu.service'),
    icon: <PapersIcon />,
    link: Routes.Services,
  },
  {
    name: t('menu.termsAndConditions'),
    icon: <PapersIcon />,
    link: Routes.TermsAndConditions,
  },
  {
    name: t('pageTitles.privacy'),
    icon: <PapersIcon />,
    link: Routes.PrivacyPolicy,
  },
];
